import React from "react";
import MT4Top from "./MT4Top/MT4Top";
import LayoutMain from "../../Elements/LayoutMain/LayoutMain";

function EducationMT4Gatsby (props) {

    return (
        <LayoutMain title={props.title} description={props.description} AllMenu={['','','','','','ElementMenuActive']}  lang={props.lang} Active={5}>
            <main className="mt4Video StandartPage">
                <div className="StandartInZeroBig">
                    <MT4Top PrerenderTexts={props.PrerenderTextsMT4Top} videoType={props.videoType} data={props.data} lang={props.lang} Active={1} mt4indicators/>

                </div>
            </main>
        </LayoutMain>

    )}

export default EducationMT4Gatsby